import React from 'react';

// TO BE REMOVED AND PARAMETERIZED IN JSON???

export default function Digital() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.851"
      height="37.85"
      viewBox="0 0 37.851 37.85"
    >
      <defs>
        <filter
          id="Path_3944"
          width="24.902"
          height="34.209"
          x="0"
          y="3.641"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur" stdDeviation="2.5"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.749"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Path_3945"
          width="24.902"
          height="34.209"
          x="12.949"
          y="3.641"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="2.5"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.749"></feFlood>
          <feComposite in2="blur-2" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Ellipse_83"
          width="24.902"
          height="24.902"
          x="6.474"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-3" stdDeviation="2.5"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.749"></feFlood>
          <feComposite in2="blur-3" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Line_54"
          width="24.902"
          height="16"
          x="6.474"
          y="4.451"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-4" stdDeviation="2.5"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.749"></feFlood>
          <feComposite in2="blur-4" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Ellipse_84"
          width="20.856"
          height="24.902"
          x="8.498"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-5" stdDeviation="2.5"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.749"></feFlood>
          <feComposite in2="blur-5" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Line_55"
          width="16"
          height="24.902"
          x="10.925"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-6" stdDeviation="2.5"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.749"></feFlood>
          <feComposite in2="blur-6" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 115">
        <g filter="url(#Path_3944)" transform="translate(8 8) translate(-8 -8)">
          <path
            fill="none"
            stroke="#f5ff00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13.614 24.51l-3.667-3.944a1.214 1.214 0 111.778-1.653l5.18 5.783v5.159h-4.046v-3.237l-4.856-5.26v-8.9a.81.81 0 011.619 0v7.284"
            data-name="Path 3944"
          ></path>
        </g>
        <g filter="url(#Path_3945)" transform="translate(8 8) translate(-8 -8)">
          <path
            fill="none"
            stroke="#f5ff00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M24.244 24.51l3.667-3.944a1.214 1.214 0 00-1.778-1.653l-5.18 5.783v5.159h4.046v-3.237l4.856-5.26v-8.9a.81.81 0 00-1.619 0v7.284"
            data-name="Path 3945"
          ></path>
        </g>
        <g filter="url(#Ellipse_83)" transform="translate(8 8) translate(-8 -8)">
          <ellipse
            cx="4.451"
            cy="4.451"
            fill="none"
            stroke="#f5ff00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Ellipse 83"
            rx="4.451"
            ry="4.451"
            transform="translate(14.47 8)"
          ></ellipse>
        </g>
        <g filter="url(#Line_54)" transform="translate(8 8) translate(-8 -8)">
          <path
            fill="none"
            stroke="#f5ff00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M8.902 0L0 0"
            data-name="Line 54"
            transform="translate(14.47 12.45)"
          ></path>
        </g>
        <g filter="url(#Ellipse_84)" transform="translate(8 8) translate(-8 -8)">
          <ellipse
            cx="2.428"
            cy="4.451"
            fill="none"
            stroke="#f5ff00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Ellipse 84"
            rx="2.428"
            ry="4.451"
            transform="translate(16.5 8)"
          ></ellipse>
        </g>
        <g filter="url(#Line_55)" transform="translate(8 8) translate(-8 -8)">
          <path
            fill="none"
            stroke="#f5ff00"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M0 8.902L0 0"
            data-name="Line 55"
            transform="translate(18.93 8)"
          ></path>
        </g>
      </g>
    </svg>
  );
}
